import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const getUserPhoneCode: UseCase<AuthRepository, 'getUserPhoneCode'> = repository => {
  return async userId => {
    return await repository.getUserPhoneCode(userId)
  }
}
